document.addEventListener('DOMContentLoaded', function() {
  const contentSection = document.querySelector('.article-template__content');

  if (contentSection) {
    let articleContent = contentSection.innerHTML;
    const regex = /\[\[(\d+)\]\]/g;

    let match;
    const foundNumbers = new Set();

    while ((match = regex.exec(articleContent)) !== null) {
      foundNumbers.add(match[1]);
    }

    articleContent = articleContent.replace(regex, (fullMatch, number) => {
      return `<sup><a href="#citation-${number}" id="reference-${number}">${number}</a></sup>`;
    });

    contentSection.innerHTML = articleContent;

    if (foundNumbers.size > 0) {
      const olTag = contentSection.querySelector('ol:last-of-type');
      const listItems = olTag.querySelectorAll('li');
        listItems.forEach((item, index) => {
          // Assuming the order of li elements corresponds to the order of foundNumbers
          // This might need adjustment if the numbering in the list is not sequential or complete
          const citationNumber = Array.from(foundNumbers)[index];
          if (citationNumber) {
            item.id = `citation-${citationNumber}`;
          }
        });

    }
  }
});
